/* eslint-disable no-unused-vars */

/* prettier-ignore */
export const endpoint = {
  user:                                                 (data = {}) => `user/show`, 
  permissions:                                          (data = {}) => `user/modules`, 
  firebase:{
    register:                                           (data = {}) => `user/token-notification/${data.token}`,
  },
  auth: {
    login:                                              (data = {}) => `auth/login`,
    logout:                                             (data = {}) => `auth/logout`,
    forgot:                                             (data = {}) => `auth/forgot`,
    reset:                                              (data = {}) => `auth/reset`,
  },
   dashboard:{
    show:                                               (data = {}) => `admin/dashboard`,
    alerts_graphic:                                     (data = {}) => `admin/dashboard/alerts`,
    alerts_list:                                        (data = {}) => `admin/dashboard/alerts-by-customer`,
    devices_graphic:                                    (data = {}) => `admin/dashboard/devices`,
    devices_list:                                       (data = {}) => `admin/dashboard/devices-by-customer`,
    access_graphic:                                     (data = {}) => `admin/dashboard/users`,
    access_list:                                         (data = {}) => `admin/dashboard/users-by-customer`,


  },
  properties:{
    show:                                               (data = {}) => `${data.context}/dashboard/${data.farm}`,
    index:                                              (data = {}) => `${data.context}/${data.farm}/properties/${data.property}`,
  },
  profile:{
    self:                                               (data = {}) => `profile`,
    show:                                               (data = {}) => `profile/show`,
  },
  users:{
    show:                                               (data = {}) => `${data.context}/users/${data.user}`,
  },
  tickets:{
    self:                                               (data = {}) => `tickets`,
    counters:                                           (data = {}) => `tickets/counters`,
    show:                                               (data = {}) => `tickets/${data.id}`,
    post:                                               (data = {}) => `tickets/${data.id}`,//POST
    close:                                               (data = {}) => `tickets/${data.id}`,//PUT
  },
  history_logs:{
    self:                                               (data = {}) => `/whatsapp/webhook/users`,
    show:                                               (data = {}) => `/whatsapp/webhook/users/farm/${data.farm}/${data.id}`,
  },
  root:{
    application:{
      show:                                             (data = {}) => `admin/account/application_ttn`,
    },
    plans:{
      show:                                             (data = {}) => `admin/plans`,
      self:                                             (data = {}) => `admin/plans/${data.id}`
    },
    users:{
      show:                                             (data = {}) => `admin/users`,
      self:                                             (data = {}) => `admin/users/${data.id}`
    },
    users_farm:{
      show:                                             (data = {}) => `admin/users?context=farm`,
      self:                                             (data = {}) => `admin/users/${data.id}`,
      reset_password:                                   (data = {}) => `admin/users/${data.id}/reset-password`,
    },
    farm_account:{
      show:                                             (data = {}) => `admin/account/farms`,
      self:                                             (data = {}) => `admin/account/farms/${data.id}`,
      active:                                             (data = {}) => `admin/account/farms/${data.id}/monitoring-status`,
    },
    functionalities:{
      show:                                             (data = {}) => `admin/functionalities`,
    },
    system_connections:{
      pool_stats:                                       (data = {}) => `admin/connections/pool-stats`,
      details:                                          (data = {}) => `admin/connections/pool-stats/${data.tenant}`,
    },
    modules:{
      show:                                             (data = {}) => `admin/modules/${data.resource}`,
      self:                                             (data = {}) => `admin/modules/${data.resource}/${data.id}`,
    },
    roles:{
      show:                                             (data = {}) => `admin/roles/${data.resource}`,
      self:                                             (data = {}) => `admin/roles/${data.resource}/${data.id}`,
    },
    devices:{
      show:                                             (data = {}) => `admin/devices`,
      logs:                                             (data = {}) => `admin/devices-logs/${data.device}`,
      self:                                             (data = {}) => `admin/devices/${data.device}`,
      detail:                                           (data = {}) => `admin/devices/${data.device}/show`,
    },
    tags:{
      show:                                             (data = {}) => `admin/tags`,
      self:                                             (data = {}) => `admin/tags/${data.tag}`,
      move:                                             (data = {}) => `admin/tags/change-farm/${data.tag}`,
      massiveMove:                                      (data = {}) => `admin/tags/change-farm/${data.farm_id}/massive`,
      history:                                          (data = {}) => `admin/tags/package-list/${data.tag}`,
      logs:                                             (data = {}) => `admin/tags/tag-log/${data.tag}`,
      import:                                           (data = {}) => `admin/import`,
      production: {
        show:                                           (data = {}) => `admin/tags/production`,
        put:                                            (data = {}) => `admin/tags/production/set-name/${data.id}`,
      },
      identification: {
        self:                                           (data = {}) => `admin/tag-import-sessions`,
        show:                                           (data = {}) => `admin/tag-import-sessions/${data.id}`,
        put:                                            (data = {}) => `admin/tag-import-sessions/${data.id}`,
        setError:                                       (data = {}) => `admin/tag-import-sessions/${data.id}/set-to-error`,
        updateByMac:                                    (data = {}) => `admin/tag-import-sessions/${data.id}/tag-name/${data.tag_name}`,
        deleteTag:                                      (data = {}) => `admin/tag-import-sessions/${data.id}/tag-name/${data.tag_name}`,
        delete:                                         (data = {}) => `admin/tag-import-sessions/${data.id}`,
        finish:                                         (data = {}) => `admin/tag-import-sessions/${data.id}/finish`,
      },
    },
    import_tags:{
      show:                                             (data = {}) => `admin/import`,
      self:                                             (data = {}) => `admin/import/${data.tag}`,
      download:                                         (data = {}) => `admin/import/${data.id}/download`,
    },
    routers:{
      show:                                             (data = {}) => `admin/routers`,
      patch:                                             (data = {}) => `admin/routers/${data.router}/locked-state`,
      move:                                             (data = {}) => `admin/routers/${data.router}`,
      self:                                             (data = {}) => `admin/routers/${data.router}`,
      history:                                          (data = {}) => `admin/routers/package-list/${data.router}`,
      logs:                                             (data = {}) => `admin/routers/router-log/${data.name}`,
    },
    routers_fixed:{
      show:                                             (data = {}) => `admin/routers`,
      update:                                           (data = {}) => `admin/routers/${data.router}/update`,
      move:                                             (data = {}) => `admin/routers/${data.router}`,
      self:                                             (data = {}) => `admin/routers/${data.router}`,
      upload:                                           (data = {}) => `admin/routers/${data.router ?? data.name}/upload`,
      history:                                          (data = {}) => `admin/routers/package-list/${data.router}`,
      logs:                                             (data = {}) => `admin/routers/router-log/${data.name}`,
    },
    movement_tags:{
      self:                                             (data = {}) => `admin/mass-tags-movement-logs`,
      show:                                             (data = {}) => `admin/mass-tags-movement-logs/${data.tag}`,
    },
    gateways:{
      show:                                             (data = {}) => `admin/gateways`,
      self:                                             (data = {}) => `admin/gateways/${data.gateway}`,
      detail:                                           (data = {}) => `admin/gateways/details/${data.gateway}`,
      archives:{
        show:                                           (data = {}) => `admin/gateways/${data.gateway}/file`,
        self:                                           (data = {}) => `admin/gateways/${data.gateway}/file/uploads`,
        delete:                                         (data = {}) => `admin/gateways/${data.gateway}/file/${data.file_name}`,
      }
    },
    release_notes:{
      self:                                              (data = {}) => `admin/release-notes`,
      id:                                                (data = {}) => `admin/release-notes/${data.id}`,
    }
  },
  farm:{
    self:                                               (data = {}) => `farm/dashboard/${data.farm}`,
    search:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/search`,
    forms:{
      cattle_batch_update:                              (data = {}) => `farm/${data.farm}/properties/${data.property}/forms/cattle-plot-update/${data.animal}`,
      cattle_delete:                                    (data = {}) => `farm/${data.farm}/properties/${data.property}/forms/delete-cattle/${data.animal}`,
      cattle_weighing:                                  (data = {}) => `farm/${data.farm}/properties/${data.property}/forms/weighting-create/${data.animal}`,
      childbirth:                                       (data = {}) => `farm/${data.farm}/properties/${data.property}/forms/childbirth-create/${data.animal}`,
      childbirth_edit:                                  (data = {}) => `farm/${data.farm}/properties/${data.property}/forms/childbirth-edit/${data.animal}`,
    },
    roles:{
      show:                                             (data = {}) => `farm/${data.farm}/roles`,
    },
    report:{
      download:                                             (data = {}) => `farm/download/report-file`,
      upload:                                             (data = {}) => `farm/${data.farm}/upload/report-file`,
      update:                                             (data = {}) => `farm/${data.farm}/report-file/${data.id}/link`,
      send_wp:                                             (data = {}) => `farm/${data.farm}/report-file/send`,
      byToken:                                            (data = {}) => `farm/${data.farm}/report-file/token/${data.token}`,
    },
    access:{
      map:                                              (data = {}) => `farm/${data.farm}/properties/${data.property}/map`,
      dashboard:                                        (data = {}) => `farm/${data.farm}/properties/${data.property}/dashboard`,
      chart:{
        bar:                                            (data = {}) => `farm/${data.farm}/properties/${data.property}/dashboard/graph/bar`,
        pie:                                            (data = {}) => `farm/${data.farm}/properties/${data.property}/dashboard/graph/pie`,
      }
    },
    breeds:{
      show:                                             (data = {}) => `farm/breeds`,
    },
    users:{
      show:                                             (data = {}) => `farm/${data.farm}/users`,
      self:                                             (data = {}) => `farm/${data.farm}/users/${data.user}`
    },
    properties:{
      show:                                             (data = {}) => `farm/${data.farm}/properties`,
      self:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}`,
      center_area:                                      (data = {}) => `farm/${data.farm}/properties/${data.property}/center_area`,
    },
    batch:{
      show:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/plots`,
      self:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/plots/${data.batch}`,
      logs:{
        show:                                           (data = {}) => `farm/${data.farm}/properties/${data.property}/plots/${data.batch}/logs`,
        self:                                           (data = {}) => `farm/${data.farm}/properties/${data.property}/plots/log/${data.batch}`,
      },
      info:{
        show:                                           (data = {}) => `farm/${data.farm}/properties/${data.property}/plots/${data.batch}/card`,
      },
      graphs:{
        hour:                                           (data = {}) => `farm/${data.farm}/properties/${data.property}/plots/${data.batch}/graph/hour-by-hour`,
        day:                                            (data = {}) => `farm/${data.farm}/properties/${data.property}/plots/${data.batch}/graph/24-hours`,
      }
    },
    cattle:{
      show:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles`,      report:                                           (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/activity/report`,
      self:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.herd}`,
      move_batch:                                       (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.herd}/plot-movement`,
      details:                                          (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.animal}/details`,
      map:                                              (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.animal}/map`,
      structures:                                       (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.animal}/structures-history`,
      childbirth:                                       (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.animal}/childbirth`,
      cattle_weighing:                                  (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.animal}/weight-history`,
      alerts:                                           (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.animal}/alerts`,
      history:                                           (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.animal}/life-history`,
      graphs:{
        hour:                                           (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.animal}/graph/hour-by-hour`,
        day:                                            (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.animal}/graph/24-hours`,
        displacement:                                   (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.animal}/graph/one-day`,
        structures:                                     (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.animal}/structures-history/graph`,
        weight:                                         (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.animal}/weight-history-list`,
      }
    },
    piquete:{
      show:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/lots`,
      self:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/lots/${data.lot}`,
      form:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/lots/list`,
      getPlots:                                         (data = {}) => `farm/${data.farm}/properties/${data.property}/lots/plots`,
      heatmap:{
        show:                                           (data = {}) => `farm/${data.farm}/properties/${data.property}/lots/${data.lot}/plots/${data.time}`,
      },
      forms:{
        new:                                            (data = {}) => `farm/${data.farm}/properties/${data.property}/lots/forms`,
        edit:                                           (data = {}) => `farm/${data.farm}/properties/${data.property}/lots/forms/${data.lot}`,
      }
    },
    imports:{
      self:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/import`,
      show:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/import/${data.import}`,
    },
    devices:{
      list:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/devices`,
      show:                                             (data = {}) => `farm/${data.farm}/devices`,
      logs:                                             (data = {}) => `farm/${data.farm}/devices/logs/${data.device}`,
      self:                                             (data = {}) => `farm/${data.farm}/devices/${data.device}`,
      detail:                                           (data = {}) => `farm/${data.farm}/devices/details/${data.device}`,
      newDetails:                                       (data = {}) => `farm/${data.farm}/properties/${data.property}/cattles/${data.animal}/details/package`,
      download:                                         (data = {}) => `farm/${data.farm}/devices/details/${data.device}/download`,
      graph:                                            (data = {}) => `farm/${data.farm}/devices/details/${data.device}/graph`,
    },
    tags:{
      show:                                             (data = {}) => `farm/${data.farm}/tags`,
      unlinked:                                         (data = {}) => `farm/${data.farm}/tags/tags-unlinked`,
      history:                                          (data = {}) => `farm/${data.farm}/tags/package-list/${data.tag}`,
      logs:                                             (data = {}) => `farm/${data.farm}/tags/tag-log/${data.tag}`,
      self:                                             (data = {}) => `farm/${data.farm}/tags/${data.tag}`,
      download:                                         (data = {}) => `farm/${data.farm}/tags/details/${data.device}/download`,
    },
    routers_mobile:{
      show:                                             (data = {}) => `farm/${data.farm}/routers/mobile`,
      logs:                                             (data = {}) => `farm/${data.farm}/routers/mobile/${data.name}/tag-log`,
      self:                                             (data = {}) => `farm/${data.farm}/routers/mobile/${data.name}`,
      history:                                          (data = {}) => `farm/${data.farm}/routers/mobile/${data.name}/package-list`,
    },
    routers_fixed:{
      show:                                             (data = {}) => `farm/${data.farm}/routers`,
      logs:                                             (data = {}) => `farm/${data.farm}/routers/${data.name}/router-log`,
      self:                                             (data = {}) => `farm/${data.farm}/routers/${data.name}`,
      update:                                           (data = {}) => `farm/${data.farm}/routers/${data.id}`,
      history:                                          (data = {}) => `farm/${data.farm}/routers/${data.name}/package-list`,
    },
    structures:{
      show:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/structures`,
      self:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/structures/${data.structure}`,
      forms:{
        create:                                         (data = {}) => `farm/${data.farm}/properties/${data.property}/structures/forms`,
        update:                                         (data = {}) => `farm/${data.farm}/properties/${data.property}/structures/forms/${data.structure}`,
      }
      
    },
    measure:{
      show:                                             (data = {}) => `farm/${data.farm}/settings/units`,
      self:                                             (data = {}) => `farm/${data.farm}/settings/units`,
    },
    settings:{
      hardware:                                         (data = {}) => `farm/${data.farm}/settings/hardware`,
      measure:                                          (data = {}) => `farm/${data.farm}/settings/units`,
      day_per_cycle:                                    (data = {}) => `farm/${data.farm}/settings/days-per-cycle`,
      growth:                                           (data = {}) => `farm/${data.farm}/settings/growth-phases`,
      alerts:                                           (data = {}) => `farm/${data.farm}/settings/point-alerts`,
      reports:                                          (data = {}) => `farm/${data.farm}/settings/reports`,
      reports_update:                                   (data = {}) => `farm/${data.farm}/settings/reports/update`,
      forms:{
        hardware_form:                                  (data = {}) => `farm/${data.farm}/forms/settings/hardware`,
        hdop_form:                                      (data = {}) => `farm/${data.farm}/forms/settings/hardware/package-accuracy`,
      }
    },
    boudaries:{
      show:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/boundaries`,
      self:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/boundaries/${data.boundary}`,
    },
    notifications:{
      show:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/notifications`,
      unread:                                           (data = {}) => `farm/${data.farm}/properties/${data.property}/notifications/unread`,
      self:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/notifications/${data.notification}`,
      read:{
        list:                                           (data = {}) => `farm/${data.farm}/properties/${data.property}/notifications/mark-as-read`,
        all:                                            (data = {}) => `farm/${data.farm}/properties/${data.property}/notifications/mark-as-read/all`,
      },
      form:{
        zero_steps_alert:                               (data = {}) => `farm/${data.farm}/properties/${data.property}/notifications/${data.notification}`,
      }
    },
    status:{
      show:                                             (data = {}) => `farm/${data.farm}/properties/${data.property}/status`,
    }
  }
}
